import { buildDynaLiveWebCallbackReportDedupeKey, reportDynaLiveWebApiLog } from '@/utils/dynaLiveWebApiLog'

export function splitUrlWithQueryParams(url = '') {
  const questionMarkIndex = url.lastIndexOf('?')
  if (questionMarkIndex === -1) {
    return {}
  }

  const queryParamsString = url.slice(questionMarkIndex + 1)
  if (!queryParamsString) {
    return {}
  }

  const queryParams = {}
  queryParamsString.split('&').forEach(param => {
    const [key, value] = param.split('=')
    if (!key) {
      return
    }
    queryParams[decodeURIComponent(key)] = decodeURIComponent(value || '')
  })

  return queryParams
}

export function extractDynaLiveWebCallbackFromUrl(url = '', reportContext = null) {
  const queryParams = splitUrlWithQueryParams(url)
  const requestId = queryParams.request_id || ''
  const bizNum = queryParams.biz_num || ''
  const msg = queryParams.msg || ''

  if (!requestId && !bizNum && !msg) {
    return null
  }

  const callback = {
    requestId,
    bizNum,
    msg
  }

  if (reportContext && typeof reportContext === 'object') {
    reportDynaLiveWebApiLog(
      'dynaLiveWebCallback',
      {
        ...reportContext,
        href: url,
        queryParams,
        callback
      },
      callback,
      {
        dedupeKey: buildDynaLiveWebCallbackReportDedupeKey(reportContext.scene || '', callback)
      }
    )
  }

  return callback
}

export function isValidDynaLiveWebCallback(callback) {
  return !!(callback && typeof callback === 'object' && (callback.requestId || callback.bizNum || callback.msg))
}

export function getDynaLiveWebCallbackSignature(callback = {}) {
  return [callback.requestId || '', callback.bizNum || '', callback.msg || ''].join('|')
}

export function stringifyQuery(query = {}) {
  return Object.keys(query)
    .filter(key => query[key] !== undefined && query[key] !== null && query[key] !== '')
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(String(query[key]))}`)
    .join('&')
}

export function buildDynaLiveWebSdkUrl({ host, accountId, appKey, lang, returnUrl }) {
  if (!host || !accountId || !appKey || !returnUrl) {
    return ''
  }

  const queryString = [
    `account_id=${encodeURIComponent(accountId)}`,
    `app_key=${encodeURIComponent(appKey)}`,
    `lang=${encodeURIComponent(lang || 'en')}`,
    `return_url=${encodeURIComponent(returnUrl)}`
  ].join('&')

  return `https://${host}/static/index.html#/?${queryString}`
}
